export const resolveGatewayType = (type: string) => {
  return type.toLowerCase() === "trimble-pre-prod" ? "PRE PROD" : "PROD";
};
